var path = '/pages/picklists/views/contacts/contacts-list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/contacts/contacts-list.tpl.html
// module id = 2300
// module chunks = 1